export enum Integration {
  Tokeet,
  Signature,
  Webhooks,
  Email,
  SMS
}
